
<script setup>
  import { LocationSearch, CheckoutButton, useOrderStore } from 'shared-vue'
  import { storeToRefs } from 'pinia';
  import { useRouter } from 'vue-router';

  const orderStore = useOrderStore();
  const { orderId, paymentSent, vendor } = storeToRefs(orderStore);
  const router = useRouter();

  function goBack() {
    console.log(vendor.value)
    if (vendor && vendor.value.slug) {
      router.replace('/restaurant/' + vendor.value.slug);

    }
    else {
      router.replace('/vendors');
    }
  }

  function paymentSuccess(val) {
    orderStore.setPaymentSent(val);
    if (val) {
      router.push({ name: 'OrderComplete', params: { orderId: orderId.value } });
    }
    else {
      alert("something went wrong")
    }
  }
</script>

<template>
  <div class="my-4">
    <LocationSearch />
  </div>
  <button @click="goBack" class="btn btn-danger my-3">< Back</button>

  <div v-if="orderId && vendor?.vId" class="content">
    <h1>Checkout</h1>
    <CheckoutButton :orderId="orderId" :onPaymentSent="paymentSuccess" />
  </div>
</template>
